import React, { useState } from "react";
import "./TemplateButtons.scss";
import toast from "react-hot-toast";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { getImageUrl } from "../../../utils/helpers/common";
import { TemplatesApi } from "../../../utils/api/Templates";
import { templatesAction } from "../../../redux/features/templatesSlice";
import WhiteLoading from "../../loading/WhiteLoading";
import { CommonEnums } from "../../../enums/common.enums";
import LockIcon2 from "../../../components/icons/LockIcon2";
import RoundTrueIcon from "../../../components/icons/RoundTrueIcon";
import PreviewTemplate from "../designTemplates/PreviewTemplate";
import PreviewModal from "../workspace/propertypost/view/PreviewModal";

interface stateType {
  isLoading: boolean;
}

const checkVideo = (type: string) => {
  let video_check = false;
  switch (type) {
    case CommonEnums?.postType?.reel_post?.key:
      video_check = true;
      break;
    case CommonEnums?.postType?.video_post?.key:
      video_check = true;
      break;
  }

  return video_check;
};

const TemplateButtons = ({
  templateData,
  onTemplateSelect,
  templateTypeId,
  postType,
}: {
  templateData: any;
  onTemplateSelect: (selectedTemplateId: string) => void;
  templateTypeId?: string;
  postType?: string;
}) => {
  const [state, setState] = useState<stateType>({
    isLoading: false,
  });
  const dispatch = useDispatch();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImages, setPreviewImages] = useState<string[]>([]);

  const [searchParams, setSearchParams] = useSearchParams();
  let type: any = searchParams?.get("post_type");

  const reduxTemplateId = useSelector(
    (state: RootState) => state?.templates?.selectedTemplateId
  );

  const template_id = templateTypeId || "";

  const [previewData, setPreviewData] = useState({
    id: "",
    src: "",
    title: "",
    post_type: "",
  });

  // const handleOpen = (data: any) => {
  //   console.log("data>>>", data);

  //   if (checkVideo(data?.post_type)) {
  //     setPreviewData({
  //       id: data?._id,
  //       src: getImageUrl(data?.template_video_ref?.compressed_file_path),
  //       title: data?.name,
  //       post_type: data?.post_type,
  //     });
  //   } else {
  //     setPreviewData({
  //       id: data?._id,
  //       src: getImageUrl(data?.template_image_ref?.compressed_file_path),
  //       title: data?.name,
  //       post_type: data?.post_type,
  //     });
  //   }
  // };

  const handleOpen = (data: any) => {
    // console.log("data>>>", data);

    const isVideo = checkVideo(data?.post_type);
    const mediaPath = isVideo
      ? data?.template_video_ref?.compressed_file_path
      : data?.template_image_ref?.compressed_file_path;

    if (mediaPath) {
      setPreviewImages([getImageUrl(mediaPath)]);
      setPreviewOpen(true);
    }
  };

  const onClickSelectTamplate = async () => {
    setState({
      ...state,
      isLoading: true,
    });
    let res = await TemplatesApi.setTemplate({
      template_type_id: template_id,
      post_type: postType,
      design_template_id: templateData?._id,
    });

    if (res?.data?.success) {
      toast.success("Template selected successfully.");
      dispatch(templatesAction?.resetTemplateDesign());
      dispatch(templatesAction?.setSelectedTemplateId(templateData?._id));
      onTemplateSelect(templateData?._id);
    } else {
      toast.error(res?.data?.message || "Internal server error!");
    }

    setState({
      ...state,
      isLoading: false,
    });
  };
  return (
    <>
      <div className="template-box-btn">
        <button
          className={`preview-btn box-btn`}
          onClick={() => handleOpen(templateData)}
        >
          Preview
        </button>
        <button
          className={`select-btn box-btn ${
            templateData?.status === CommonEnums?.status?.published
              ? templateData?.selected
                ? "button-active"
                : ""
              : "button-disable"
          } `}
          disabled={!["published", "active"].includes(templateData?.status)}
          onClick={() => onClickSelectTamplate()}
        >
          {state.isLoading ? (
            <div className="css-loading-spinner"></div>
          ) : (
            <>
              <span className="lock-icon">
                <LockIcon2 />
              </span>
              <span className="round-true-icon">
                <RoundTrueIcon />
              </span>
              {templateData?.selected &&
              templateData?.status === CommonEnums?.status?.published
                ? "Selected"
                : "Select"}
            </>
          )}
        </button>
      </div>

      {/* <PreviewTemplate
        previewData={previewData}
        setPreviewData={setPreviewData}
      /> */}
      <PreviewModal
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        images={previewImages}
      />
    </>
  );
};

export default TemplateButtons;
